import React, { useState, useEffect } from 'react';
import styles from './Contact.module.css';
import { FaWhatsapp, FaUserAlt, FaCarAlt } from 'react-icons/fa';
import { MdEmail, MdAccessTime, MdPhone, MdMessage } from 'react-icons/md';
import { BiChevronDown } from 'react-icons/bi';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    car: '',
    message: '',
  });

  useEffect(() => {
    document.body.classList.add('contact-page');
    return () => {
      document.body.classList.remove('contact-page');
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const phoneNumber = '+971507079549';
    const text = `Hello! My name is ${formData.name}. Email: ${formData.email}, Phone: ${formData.phone}, Car Type: ${formData.car}, Message: ${formData.message}`;
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(text)}`;
    window.open(url, '_blank'); // يفتح WhatsApp في نافذة جديدة
  };

  return (
    <div className={styles.contactSection}>
      <div className={styles.contactHeader}>
        <h1>Contact Our Team</h1>
        <div className={styles.underline}></div>
        <p>
          Have questions about our premium fleet? Our team is ready to assist with your car rental needs.
        </p>
      </div>

      <div className={styles.contentWrapper}>
        {/* Information Section */}
        <div className={styles.infoCard}>
          <div className={styles.cardHeader}>
            <BiChevronDown className={styles.chevron} />
            <h2>Our Information</h2>
          </div>

          <div className={styles.infoContent}>
            <div className={styles.infoItem}>
              <FaWhatsapp className={styles.infoIcon} />
              <div>
                <h3>WhatsApp</h3>
                <p>+971507079549</p>
              </div>
            </div>

            <div className={styles.infoItem}>
              <MdEmail className={styles.infoIcon} />
              <div>
                <h3>Email</h3>
                <p>contact@hexagonservices.com</p>
              </div>
            </div>

            <div className={styles.infoItem}>
              <MdAccessTime className={styles.infoIcon} />
              <div>
                <h3>Hours</h3>
                <p>Mon-Sat: 8AM-8PM</p>
                <p>Sunday: 10AM-6PM</p>
              </div>
            </div>

            <div className={styles.specialOffer}>
              <h3>Special Offer!</h3>
              <p>Book for 3+ days and get 10% discount</p>
            </div>
          </div>
        </div>

        {/* Form Section */}
        <div className={styles.formCard}>
          <div className={styles.cardHeader}>
            <BiChevronDown className={styles.chevron} />
            <h2>Send Your Inquiry</h2>
          </div>
          <p className={styles.formSubtitle}>Fill out the form and we'll get back to you promptly</p>

          <form onSubmit={handleSubmit}>
            <div className={styles.formGrid}>
              <div className={styles.inputGroup}>
                <FaUserAlt className={styles.inputIcon} />
                <input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className={styles.inputGroup}>
                <MdEmail className={styles.inputIcon} />
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className={styles.inputGroup}>
                <MdPhone className={styles.inputIcon} />
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className={styles.inputGroup}>
                <FaCarAlt className={styles.inputIcon} />
                <select name="car" value={formData.car} onChange={handleChange} required>
                  <option value="">Select Car Type</option>
                  <option value="sedan">Sedan</option>
                  <option value="suv">SUV</option>
                  <option value="luxury">Luxury</option>
                </select>
              </div>
            </div>

            <div className={styles.textareaGroup}>
              <MdMessage className={styles.messageIcon} />
              <textarea
                name="message"
                placeholder="Tell us about your rental needs..."
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <button type="submit" className={styles.submitButton}>
              Send via WhatsApp <FaWhatsapp />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
